module.exports = __webpack_public_path__ + "static/media/ninja-hero.70564b08.mp4";